import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHouse = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 309,
	height: 273,
	fill: "none",
	viewBox: "0 0 309 273",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#822235",
			d: "M209.444 39.97v14.252h13.361V39.97z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2e1a0b",
			d: "M201.651 39.97v14.252h8.016V39.97z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#453223",
			d: "M211.255 235.465c0-29.827-4.936-135.65-4.936-137.255l50.353-33.553 44.43 41.467-12.462 129.341z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_22317_35485",
			width: 96,
			height: 171,
			x: 206,
			y: 64,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#d7697f",
				stroke: "#392617",
				strokeWidth: .355,
				d: "M206.32 234.477V97.795l49.366-33.139 45.417 42.455-13.66 127.634z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#392617",
			strokeWidth: .786,
			mask: "url(#mask0_22317_35485)",
			children: [
				/* @__PURE__ */ _jsx("line", {
					x2: 169.82,
					y1: -.393,
					y2: -.393,
					transform: "matrix(0 1 1 0 206.306 60.704)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 84.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 98.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 112.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 126.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 140.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 154.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 168.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 182.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 196.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 210.912)"
				}),
				/* @__PURE__ */ _jsx("line", {
					x2: 193.516,
					y1: -.393,
					y2: -.393,
					transform: "matrix(-1 0 0 1 350.468 224.912)"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#392617",
			d: "m101.658 233.487 111.569.001-4.936-130.328H93.761z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#200f02",
			d: "M84.875 118.878c.712 2.494 93.48 2.107 122.43 1.068l47.597-49.345c13.51 14.103 42.043 43.023 48.1 45.873s6.384-1.782 5.79-4.454l-52.108-50.327H145.103c-8.016 4.9-61.12 54.067-60.228 57.185"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f4f9fe",
			d: "M156.952 51.825c24.989-2.403 55.798 2.434 81.54.037.257-.024.524-.087.768-.172 24.298-8.466 16.241 12.772-.381 26.786-18.737 15.798-20.324 44.431-45.397 44.431-54.304 0-164.362 24.666-90.833-34.557 8.319-6.7 26.086-33.812 54.303-36.525"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f4f9fe",
			d: "M305.052 111.058c-6.319-.79-38.178-32.582-50.355-46.404-9.215-6.253-22.116-19.154 0-12.835 27.645 7.898 58.253 60.227 50.355 59.239"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2d1d0e",
			d: "M271.485 178.191h-29.62v55.29h29.62z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 5.924,
			height: 55.29,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 273.457 178.191)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 5.924,
			height: 55.29,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 247.787 178.191)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 5.924,
			height: 35.544,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(0 -1 -1 0 275.431 184.116)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.057,
			cy: 1.057,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(-1 0 0 1 265.989 196.442)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(-1 0 0 1 266.294 194.409)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(-1 0 0 1 266.195 192.68)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.057,
			cy: 1.057,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(-1 0 0 1 265.175 191.251)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(-1 0 0 1 264.155 189.625)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(-1 0 0 1 262.426 188.81)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 251.882,
			cy: 197.499,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 251.789,
			cy: 195.682,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 251.895,
			cy: 193.953,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 252.697,
			cy: 192.308,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 253.93,
			cy: 190.898,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 255.656,
			cy: 190.082,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 255.916,
			cy: 189.832,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(37.92 255.916 189.832)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 257.764,
			cy: 189.477,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(37.92 257.764 189.477)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 259.626,
			cy: 189.9,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(37.92 259.626 189.9)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 264.932,
			cy: 195.467,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(-180 264.932 195.467)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 265.021,
			cy: 197.284,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(-180 265.021 197.284)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 264.922,
			cy: 199.014,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(-180 264.922 199.014)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 264.118,
			cy: 200.657,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(-180 264.118 200.657)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 262.882,
			cy: 202.07,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(-180 262.882 202.07)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 261.153,
			cy: 202.884,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(-180 261.153 202.884)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.057,
			cy: 1.057,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(1 0 0 -1 250.825 196.523)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(1 0 0 -1 250.516 198.557)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(1 0 0 -1 250.622 200.287)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.057,
			cy: 1.057,
			r: .932,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(1 0 0 -1 251.64 201.711)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(1 0 0 -1 252.658 203.343)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "matrix(1 0 0 -1 254.383 204.157)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(142.08 93.512 146.874)scale(-1 1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 1.273,
			cy: 1.273,
			r: 1.148,
			fill: "#0f7166",
			stroke: "#3b6e6b",
			strokeWidth: .251,
			transform: "rotate(142.08 94.516 146.982)scale(-1 1)"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 6.972,
			cy: 6.972,
			r: 6.22,
			stroke: "#3b6e6b",
			strokeWidth: 1.505,
			transform: "matrix(-1 0 0 1 265.379 189.316)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c53351",
			d: "M262.07 197.604c-.529-1.666-1.705-1.232-2.227-.807-.51.38-1.528 1.528-1.528 3.081 1.472-.063 4.283-.608 3.755-2.274m-2.424.445c.101-.081.778-.424.965.155.285.886-1.024 1.123-1.819 1.157.26-.733.54-1.06.854-1.312"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c53351",
			d: "m262.07 197.604.088-.028zm-2.227-.807.059.073-.003.002zm-1.528 3.081.004.093-.097.005v-.098zm1.331-1.829-.058-.072zm.965.155.088-.029zm-1.819 1.157.004.093-.137.006.046-.13zm3.278-1.757-.089.028c-.257-.81-.66-1.082-1.038-1.123-.39-.043-.79.156-1.041.36l-.059-.072-.059-.072c.271-.22.72-.451 1.18-.401.473.052.923.396 1.194 1.252zm-2.227-.807.056.075c-.496.369-1.491 1.493-1.491 3.006h-.186c0-1.592 1.042-2.764 1.565-3.155zm-1.528 3.081-.004-.092c.73-.032 1.788-.183 2.595-.529.403-.174.734-.392.932-.659.195-.263.266-.578.143-.966l.089-.028.088-.028c.141.445.06.822-.17 1.133-.227.305-.592.539-1.009.718-.835.359-1.919.512-2.66.544zm1.331-1.829-.058-.072a1.14 1.14 0 0 1 .498-.19.6.6 0 0 1 .353.055.55.55 0 0 1 .26.333l-.088.029-.089.028c-.04-.125-.103-.191-.17-.226a.43.43 0 0 0-.245-.035 1 1 0 0 0-.403.151zm.965.155.088-.029c.079.245.049.456-.062.629-.109.169-.289.292-.493.383-.407.181-.947.25-1.348.267l-.004-.093-.004-.093c.394-.017.906-.084 1.281-.251.187-.084.33-.188.411-.314.079-.121.106-.273.042-.471zm-1.819 1.157-.087-.031c.265-.748.554-1.089.883-1.353l.058.072.058.073c-.299.24-.57.552-.824 1.27z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c53351",
			d: "M255.337 196.851c-1.291 1.096-.509 2.127.044 2.505.508.382 1.867 1.013 3.238.486-.557-1.453-1.991-4.086-3.282-2.991m.992 2.34c-.283-.19-.651-.764-.071-1.112.534-.321 1.515.702 1.797 1.436-.706.272-1.466-.132-1.726-.324"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c53351",
			d: "m255.337 196.851-.057-.071zm.044 2.505.052-.079.003.002zm3.238.486.085-.037.035.09-.091.035zm-2.29-.651.052-.079.003.002zm-.071-1.112-.045-.081zm1.797 1.436.085-.037.035.091-.091.034zm-2.718-2.664.057.072c-.313.266-.495.523-.587.761a1.1 1.1 0 0 0-.05.664c.096.412.411.747.676.929l-.052.079-.053.079c-.287-.196-.639-.565-.75-1.038a1.3 1.3 0 0 1 .058-.778c.107-.275.312-.558.644-.839zm.044 2.505.055-.077c.245.184.701.432 1.264.569.562.137 1.225.161 1.889-.094l.03.088.029.088c-.707.272-1.409.244-1.996.102a3.8 3.8 0 0 1-1.327-.599zm3.238.486-.086.037c-.276-.722-.77-1.733-1.35-2.425-.291-.347-.596-.605-.899-.713-.296-.105-.594-.069-.89.182l-.057-.072-.057-.071c.349-.297.715-.343 1.068-.217.347.123.677.409.976.765.598.714 1.1 1.746 1.38 2.477zm-2.29-.651-.052.079a1.02 1.02 0 0 1-.396-.549.6.6 0 0 1 .019-.382.72.72 0 0 1 .313-.341l.045.081.044.081a.53.53 0 0 0-.233.247.4.4 0 0 0-.01.26.85.85 0 0 0 .322.445zm-.071-1.112-.045-.081c.167-.1.359-.089.544-.022s.377.195.555.353c.356.315.681.766.828 1.149l-.085.037-.086.037c-.135-.351-.441-.779-.779-1.078a1.6 1.6 0 0 0-.499-.32q-.236-.086-.389.006zm1.797 1.436.029.088c-.378.146-.765.109-1.087.014a2.4 2.4 0 0 1-.723-.349l.055-.077.055-.077a2.3 2.3 0 0 0 .668.322c.3.088.645.117.973-.009z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c53351",
			stroke: "#c53351",
			strokeWidth: .691,
			d: "M259.439 201.544c-.244-.907-.539-1.281-1.289-1.759l.426-.227c.944.28 1.322.627 1.864 1.412h-.77z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#c53351",
			stroke: "#c53351",
			strokeWidth: .691,
			d: "M257.307 201.562c.244-.907.539-1.282 1.289-1.76l-.426-.227c-.944.28-1.322.627-1.864 1.412h.77z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m251.036 176.046 15.753.243c.351.005.7-.057 1.043-.134 3.398-.756 6.612 2.043 4.817 3.695-1.858 1.711-7.541-.343-9.319 1.891-3.023 3.8-5.864 2.303-8.695.609-2.832-1.695-4.195-2.095-7.439.115-3.245 2.209-2.437-.213-3.304-1.977s1.627-4.528 7.144-4.442M0 264.859c0 16.843 82.056 0 140.093 0s101.802-5.784 101.802-22.627c-23.696-11.71-43.765-38.368-101.802-38.368S0 248.016 0 264.859"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 22.109,
			height: 28.286,
			fill: "#dcad54",
			transform: "matrix(-1 0 0 1 135.571 151.524)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 4.877,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 137.198 150.548)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 4.877,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 137.198 177.534)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 3.902,
			fill: "#1d0f04",
			transform: "matrix(0 -1 -1 0 115.412 181.11)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 3.902,
			fill: "#1d0f04",
			transform: "matrix(0 -1 -1 0 136.219 179.81)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16.907,
			height: 1.301,
			fill: "#6b5757",
			transform: "matrix(-1 0 0 1 132.32 166.156)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 22.109,
			height: 1.301,
			fill: "#6b5757",
			transform: "matrix(0 -1 -1 0 124.515 177.534)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 22.109,
			height: 28.286,
			fill: "#dcad54",
			transform: "matrix(-1 0 0 1 184.938 151.524)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 4.877,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 186.564 150.547)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 4.877,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 186.564 177.534)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 3.902,
			fill: "#1d0f04",
			transform: "matrix(0 -1 -1 0 164.777 181.11)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 3.902,
			fill: "#1d0f04",
			transform: "matrix(0 -1 -1 0 185.587 179.809)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16.907,
			height: 1.301,
			fill: "#6b5757",
			transform: "matrix(-1 0 0 1 181.686 166.155)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 22.109,
			height: 1.301,
			fill: "#6b5757",
			transform: "matrix(0 -1 -1 0 173.882 177.534)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M119.892 148.581c3.187.296 3.567.231 6.53.496.353.031.71-.008 1.062-.043 2.325-.233 4.177 1.826 2.835 2.863-1.422 1.1-5.154-.64-6.565.831-2.401 2.501-4.226 1.302-6.029-.035s-2.705-1.69-5.122-.314c-2.418 1.376-2.327-1.322-1.068-1.829 3.536-1.424 4.572-2.322 8.357-1.969m49.366 1.569c3.187.297 3.567.232 6.53.497.353.031.71-.008 1.062-.043 2.325-.233 4.177 1.825 2.835 2.863-1.422 1.1-5.154-.64-6.565.83-2.4 2.502-4.226 1.303-6.028-.034-1.803-1.337-2.706-1.69-5.123-.314s-2.327-1.322-1.068-1.829c3.536-1.424 4.572-2.322 8.357-1.97m8.964 29.033c5.529-1.58.329-2.633-2.962-2.962l-7.447.987c-7.899-.987-4.006 2.765-2.426 1.975 1.974-.988 5.923 1.974 12.835 0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 22.109,
			height: 28.286,
			fill: "#dcad54",
			transform: "matrix(-1 0 0 1 269.848 117.957)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 4.877,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 271.473 116.979)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 4.877,
			fill: "#1d0f04",
			rx: .786,
			transform: "matrix(-1 0 0 1 271.473 143.965)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 3.902,
			fill: "#1d0f04",
			transform: "matrix(0 -1 -1 0 249.687 147.541)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 26.986,
			height: 3.902,
			fill: "#1d0f04",
			transform: "matrix(0 -1 -1 0 270.497 146.242)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16.907,
			height: 1.301,
			fill: "#6b5757",
			transform: "matrix(-1 0 0 1 266.595 132.587)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 22.109,
			height: 1.301,
			fill: "#6b5757",
			transform: "matrix(0 -1 -1 0 258.791 143.965)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M263.136 145.614c5.529-1.58.329-2.633-2.962-2.962l-7.447.987c-7.899-.987-4.006 2.765-2.426 1.975 1.974-.987 5.923 1.975 12.835 0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 43.442,
			height: 9.873,
			fill: "#9f9f9f",
			rx: .786,
			transform: "matrix(-1 0 0 1 279.383 225.586)"
		})
	]
});
export default SvgHouse;
